// 契約書確認モーダル
import React from 'react';
import { Modal } from 'react-bootstrap';
import Heading from './Heading';
import RowTemplate from '../atoms/RowTemplate';
import { InputGroup } from 'react-bootstrap';
import Messages from './Messages';
import ShowDocument from './ShowDocument';
import CenterButton from '../atoms/CenterButton';

interface ContractDocument {
  id: number;
  contract_name: string;
  file_name: string;
  base64: string;
}

interface Props {
  toggleShow: boolean;
  contract_document: ContractDocument[];
  active_document?: ContractDocument;
  is_download_disabled?: boolean;
  toggleClose: React.MouseEventHandler;
  handleChange: (document: ContractDocument) => void;
  handleClick: VoidFunction;
}

const ConfirmContractModal: React.FC<Props> = ({
  contract_document,
  active_document,
  toggleShow,
  is_download_disabled,
  toggleClose,
  handleChange,
  handleClick,
}) => {
  return (
    <Modal
      id="contract-preview-modal"
      size="lg"
      show={toggleShow}
      onHide={toggleClose}
      animation={false}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Heading label={'契約書確認'} size={'m'} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <RowTemplate
            label="契約書の選択"
            display_border
            content={
              <div className="p-radio">
                <InputGroup>
                  {contract_document.map(document => {
                    return (
                      <label className="radio-label" key={document.id}>
                        <input
                          type="radio"
                          name="contract_document"
                          defaultChecked={document.id === contract_document[0].id}
                          onChange={() => handleChange(document)}
                          className="input-radio"
                        />
                        <span className="radio-icon"></span>
                        <div>{document.contract_name}</div>
                      </label>
                    );
                  })}
                </InputGroup>
                <Messages help_msg="※選択に応じてプレビューおよびダウンロードされる契約書が切り替わります" />
              </div>
            }
          />
        </div>
        <div className="container-box my-5">
          {active_document && <ShowDocument url={active_document.base64} />}
          <div className="my-5"></div>
          <CenterButton
            label="ダウンロード"
            handleClick={handleClick}
            is_disabled={is_download_disabled}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmContractModal;
